import React from 'react';

const LockClosed = ({ fill = 'white', className }: { fill?: string; className?: string }) => (
  <svg
    width="46"
    height="56"
    viewBox="0 0 46 56"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="lock-closed-alt">
      <g id="1noun-lock-locked-4020631 3" clipPath="url(#clip0_1619_22394)">
        <g id="Page-1">
          <g id="noun-lock-locked-4020631">
            <path
              id="Shape"
              d="M38.4958 20.9895H36.757V14.2828C36.757 6.27222 30.982 0 22.7226 0C14.4635 0 8.81247 6.3962 8.81247 14.2828V20.9276H7.0737C3.22367 20.9276 0.118717 24.0325 0.0563965 27.9449V48.9343C0.0563965 52.7844 3.16135 55.8893 7.0737 55.9516H38.4958C42.3458 55.9516 45.4508 52.8467 45.5131 48.9343V27.9438C45.5131 24.0937 42.3458 20.9888 38.4958 20.9888V20.9895ZM11.5138 14.2828C11.5138 8.32104 16.3887 2.36852 22.7224 2.36852C28.9943 2.36852 34.0554 8.19685 34.0554 14.2828L33.8336 20.9276L11.7352 20.9272V20.9895L11.5138 14.2828ZM43.0823 48.934C43.0823 50.859 40.4209 53.5204 38.4959 53.5204H7.07381C5.14885 53.5204 2.48746 50.859 2.48746 48.934C2.48746 48.3988 2.48746 47.9973 2.48746 47.7297C2.48746 43.333 2.48746 36.738 2.48746 27.9446C2.48746 26.0196 5.14885 23.9127 7.07381 23.9127L38.4959 23.8018C40.4209 23.8018 43.0823 26.0196 43.0823 27.9446V48.934ZM24.5235 38.0047H24.4616H24.5235V43.7178C24.5235 44.7115 23.7161 45.4566 22.7847 45.4566C21.7911 45.4566 21.046 44.6492 21.046 43.7178V38.0047H21.1079H21.046C19.9903 37.3835 19.3072 36.2659 19.3072 34.9617C19.3072 33.0368 20.8597 31.4843 22.7846 31.4843C24.7096 31.4219 26.2621 32.9745 26.2621 34.9617C26.2623 36.266 25.5792 37.3836 24.5235 38.0047Z"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1619_22394">
        <rect width="45.5762" height="56" />
      </clipPath>
    </defs>
  </svg>
);

export default LockClosed;
